import { compose, createStore, applyMiddleware, Store } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducers from './legacyfrontend/redux/reducers/index-reduces';
import initialState from './legacyfrontend/redux/reducers/initial-state';
import {
  isClient,
  isServer,
  getWindow,
  safeSessionStorage,
  safeStringify,
} from './legacyfrontend/helpers/ssr-helper';

// Type for the root state based on the reducers
type RootState = ReturnType<typeof reducers>;

// Type for the store
type AppStore = Store<RootState>;

// Type for the preloaded state
type PreloadedState = RootState | undefined;

const win = getWindow();
const preloadedState: PreloadedState = isServer ? initialState : win?.__PRELOADED_STATE__;
const composeEnhancers = isServer
  ? compose()
  : win?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose();

const store: AppStore = createStore(
  reducers,
  preloadedState,
  composeEnhancers(applyMiddleware(thunkMiddleware)),
);

if (isClient) {
  setTimeout(() => {
    const state = store.getState();
    const templateData = state?.applicationState;
    const applicationId = state?.applicationState?.applicationId;

    if (templateData && applicationId) {
      try {
        const dataToSave = {
          ...templateData,
          timestamp: Date.now(),
          applicationId,
        };

        const safeJsonString = safeStringify(dataToSave);
        safeSessionStorage.setItem('templateData', safeJsonString);
      
} catch (error) {
        console.warn('Error saving template data to sessionStorage:', error);
      
}
    
}
  
}, 100);

}

export default store;
